<template>
  <div class="search-box">
    <img class="search-icon" :src="searchIcon" :alt="placeholder" @click="showMore">
      <popover
        :trigger="trigger"
        :append-to-body="false"
        :visible-arrow="false"
      >
        <div class="search-text-wrapper" slot="reference">
          <input class="search-text" type="text" v-model="key" @keyup.enter="showMore" :placeholder="placeholder">
          <img class="icon-close" src="./close.png" :alt="$t('close')" v-show="key && key.length" @click="clear">
        </div>
        <ul class="search-list">
          <li class="search-item" v-for="item in productList" :key="item.productName" @click="chooseProduct(item)">{{ item.productName }}</li>
          <li class="search-item" @click="showMore">{{ $t('showMore') }}</li>
        </ul>
      </popover>
  </div>
</template>

<script>
import { Popover } from 'element-ui';
import { getProductsByKey } from '@/apis/base';

export default {
  props: {
    searchIcon: {
      type: String,
      default: require('./search.png')
    },
    placeholder: {
      type: String
    },
    showResult: Boolean,
    value: [String],
    autoInit: Boolean
  },
  components: {
    Popover
  },
  data () {
    return {
      showList: false,
      key: '',
      productList: []
    };
  },
  computed: {
    trigger () {
      return this.showResult ? 'focus' : 'manual';
    }
  },
  watch: {
    key (val) {
      if (this.showResult) {
        this.doSearch(val);
      }
    }
  },
  methods: {
    doSearch (v) {
      getProductsByKey(v).then(res => {
        if (!res.success) {
          return;
        }
        const data = res._data;
        this.productList = data.productList.slice(0, 10);
        this.$emit('resultChange', this.productList);
      });
    },
    chooseProduct (item) {
      this.$emit('chooseProduct', item);
    },
    showMore () {
      if (!this.showResult) {
        this.doSearch(this.key);
      }
      this.$emit('showMoreSearch', this.key);
    },
    clear () {
      this.key = '';
    }
  },
  mounted () {
    if (this.autoInit) {
      this.doSearch();
    }
  }
};
</script>

<style scoped>
@import 'config.css';

.search-box {
  position: relative;
  padding-left: 40px;
  height: 50px;
  background: #F5F5F5;
}

.search-text-wrapper {
  position: absolute;
  left: 40px;
  right: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  margin-top: -10px;
}

.search-text {
  width: 100%;
  height: 100%;
  padding: 0;
  padding-right: 10px;
  padding-left: 10px;
  border: 0;
  outline: none;
  background-color: transparent;
}

/deep/ .el-popover {
  width: 100%;
  left: 0!important;
}

.search-item {
  padding: 0 10px;
  line-height: 49px;
  cursor: pointer;
  color: $global-muted-color;
  /* border-bottom: 1px solid $global-gray; */
}

.search-item:hover {
  color: $global-base-color;
  /* background-color: $global-disabled-bgc; */
}

.icon-close {
  padding: 10px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
